export default "__VITE_ASSET__DM7kz90r__"